/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEquipmentGroup.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/equipment-group";

export class AutogenModelEquipmentGroup<RowType extends ModelRow> extends Endpoint<RowType, RowEquipmentGroupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEquipmentGroup extends ModelRow<RowEquipmentGroupFields> {
	constructor(values?: Partial<RowEquipmentGroupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEquipmentGroupFields {
	company_id: string;
	currentmovement_id: string;
	equipment_group_id: string;
	equipment_id: string;
	equipment_type_id: string;
	id: string;
	trailer_dropped: string;
	type_sequence: number;
}

